import { render } from "./Interruptor.vue?vue&type=template&id=b8c17852&scoped=true"
import script from "./Interruptor.vue?vue&type=script&lang=js"
export * from "./Interruptor.vue?vue&type=script&lang=js"

import "./Interruptor.vue?vue&type=style&index=0&id=b8c17852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c17852"]])

export default __exports__